import {
	AfterViewInit,
	Component,
	ElementRef,
	OnInit,
	Renderer2,
	ViewChild,
} from '@angular/core';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { Store } from '@ngrx/store';
import { DxDataGridComponent } from 'devextreme-angular';
import { map, Observable } from 'rxjs';

import { ComponentIcons } from '../../../../ui/app-components.icons';
import { DcLoaders } from '../../../../ui/app-loaders';
import {
	getPublicationHistories,
	refreshPublicationHistories,
	SubscriptionSelector,
} from '../../../store';
import { HistoryListViewProvider } from './history-list-view.provider';
import { HistoryListEntity } from './history-list.entity';
import { HistoryListProvider } from './history-list.provider';

@Component({
	selector: 'app-history-list-modal',
	templateUrl: './history-list-modal.component.html',
	styleUrls: ['./history-list-modal.component.scss'],
	providers: [HistoryListProvider, HistoryListViewProvider],
})
export class HistoryListModalComponent
	extends DcBaseComponent
	implements OnInit, AfterViewInit
{
	protected readonly DcLoaders = DcLoaders;
	protected readonly ComponentIcons = ComponentIcons;

	@ViewChild(DxDataGridComponent)
	public grid: DxDataGridComponent | null = null;

	public vo$: Observable<{
		historyList: HistoryListEntity;
	}>;

	public constructor(
		private readonly historyListProvider: HistoryListProvider,
		private readonly historyListViewProvider: HistoryListViewProvider,
		private readonly selector: SubscriptionSelector,
		private readonly store: Store,
		private readonly renderer: Renderer2,
		private readonly elemRef: ElementRef
	) {
		super();
		this.cmpId = 'history-list-modal';

		const historyList$ = this.selector
			.getHistorySubscription$()
			.pipe(map((items) => this.historyListProvider.setListElements(items)));

		this.vo$ = combineAll({
			historyList: historyList$,
		});
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.triggerInit();
	}

	public override ngAfterViewInit(): void {
		super.ngAfterViewInit();
		setTimeout(
			() =>
				this.historyListViewProvider.adjustHeights(this.elemRef, this.renderer),
			750
		);
	}

	public search(searchTerm: string): void {
		if (!this.grid) {
			return;
		}
		this.grid.instance.searchByText(searchTerm.trim());
	}

	public refresh(): void {
		this.store.dispatch(refreshPublicationHistories());
	}

	private triggerInit(): void {
		this.store.dispatch(getPublicationHistories());
	}
}
